<div class="flex justify-between align-center">
  <h2>Terms and conditions</h2>

  <button
    matButton="outlined"
    class="primary-button add-btn"
    matTooltip="Add new term"
    (click)="createTerm()">
    <mat-icon>add</mat-icon>
    add new term
  </button>
</div>

<div
  class="flex flex-gap-md nowrap"
  cdkDropListGroup>
  <div class="container">
    <h3>Unlinked terms</h3>

    <div
      cdkDropList
      class="list"
      id="unlinkedList"
      [cdkDropListData]="notLinkedTermsAndConditions()"
      (cdkDropListDropped)="drop($event)">
      @for (term of notLinkedTermsAndConditions(); track term.guid) {
        <div
          class="box"
          cdkDrag>
          <div class="column-container name">
            <span class="text-muted">Name</span>
            <a
              class="cursor-pointer"
              (click)="downloadTerm(term)">
              {{ term.name }}
              @if (term.isGlobal) {
                <mat-icon
                  matTooltip="Global term"
                  class="primary-icon mat-icon-sm m-l-half">
                  public
                </mat-icon>
              }
            </a>
          </div>
          <div class="column-container relevance">
            <span class="text-muted">Relevance</span>
            <span>{{ term.relevance }}</span>
          </div>
          <div class="column-container date">
            <span class="text-muted">Published date</span>
            <span>{{ term.publishedTimestamp | date: 'dd MMM yy' }}</span>
          </div>
          <button
            matIconButton
            aria-label="service offering options"
            [matMenuTriggerFor]="actionsMenu"
            [matMenuTriggerData]="{ item: term }"
            [disabled]="false">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      } @empty {
        <p class="no-data">No terms and conditions available</p>
      }
    </div>
  </div>

  <div class="container">
    <h3>Linked terms</h3>

    <div
      cdkDropList
      class="list"
      id="linkedList"
      [cdkDropListData]="linkedTermsAndConditions()"
      (cdkDropListDropped)="drop($event)">
      @for (linkedTerm of linkedTermsAndConditions(); track linkedTerm.guid) {
        <div
          class="box"
          cdkDrag>
          <div class="column-container name">
            <span class="text-muted">Name</span>
            <a
              class="cursor-pointer flex align-center"
              (click)="downloadTerm(linkedTerm)">
              {{ linkedTerm.name }}
              @if (linkedTerm.isGlobal) {
                <mat-icon
                  matTooltip="Global term"
                  class="primary-icon mat-icon-sm m-l-half">
                  public
                </mat-icon>
              }
            </a>
          </div>
          <div class="column-container relevance">
            <span class="text-muted">Relevance</span>
            <span>{{ linkedTerm.relevance }}</span>
          </div>
          <div class="column-container date">
            <span class="text-muted">Published date</span>
            <span>{{ linkedTerm.publishedTimestamp | date: 'dd MMM yy' }}</span>
          </div>
          <button
            matIconButton
            aria-label="service offering options"
            [matMenuTriggerFor]="actionsMenu"
            [matMenuTriggerData]="{ item: linkedTerm }"
            [disabled]="false">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      } @empty {
        <p class="no-data">No terms and conditions available</p>
      }
    </div>
  </div>
</div>

<mat-menu
  #actionsMenu="matMenu"
  role="menu">
  <ng-template
    matMenuContent
    let-item="item">
    <button
      (click)="updateTerm(item)"
      mat-menu-item>
      <mat-icon>update</mat-icon>
      Update
    </button>
    <button
      (click)="showHistory(item)"
      mat-menu-item>
      <mat-icon>schedule</mat-icon>
      Show history
    </button>
    <button
      (click)="deleteTerm(item)"
      mat-menu-item>
      <mat-icon>delete</mat-icon>
      Delete file
    </button>
  </ng-template>
</mat-menu>

<ng-template
  #termTemplate
  let-term="term">
  <div
    class="box"
    cdkDrag>
    <a
      class="cursor-pointer"
      (click)="downloadTerm(term)">
      {{ term.name }}
    </a>
    <span>{{ term.relevance }}</span>
    <span>{{ term.publishedTimestamp | date: 'dd MMM yy' }}</span>
    <button
      matIconButton
      aria-label="service offering options"
      [matMenuTriggerFor]="actionsMenu"
      [matMenuTriggerData]="{ item: term }"
      [disabled]="false">
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
</ng-template>
